import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import  { DebtorsAndCreditorsListView } from "./debtorsAndCreditorsList-view"
import { downloadFile } from "src/uicomponents/components/utilities";

export class DebtorsAndCreditorsListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'لیست بدهکاران و بستانکاران';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.balances = ObservableArray.create<singleBalance>();
        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new DebtorsAndCreditorsListView();
    }
    public getTypeId(): string {
        return "VM-0E145479-3164-47EC-9589-7330D5560A3D"
    }
    public set balances(v: ObservableArray<singleBalance>) { this._balances = v; } public get balances(): ObservableArray<singleBalance> { return this._balances;} private _balances: ObservableArray<singleBalance>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;

    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/AccountingServices/DebtorsAndCreditorsList',{
            });
            this.balances.update(...result.FoundParticipants.map((x,i)=>{
                let r = new singleBalance(this);
                r.index = i+1;
                r.participantCode = x.Code;
                r.participantId = x.Id;
                r.participantName = x.Name;
                r.totalCredit = x.TotalCredit;
                r.totalDebt = x.TotalDebt;
                r.totalBalance = x.TotalBalance;
                return r;
            }))
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async export(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/AccountingServices/DebtorsAndCreditorsExport',{
            });
            downloadFile(result.ExcelFile, `Debtors And Creditors.xlsx`);
            return result;
        } catch (ex) {
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }


}

export class singleBalance extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set participantId(v: string) { this._participantId = v; } public get participantId(): string { return this._participantId;} private _participantId: string;
    public set participantName(v: string) { this._participantName = v; } public get participantName(): string { return this._participantName;} private _participantName: string;
    public set participantCode(v: string) { this._participantCode = v; } public get participantCode(): string { return this._participantCode;} private _participantCode: string;
    public set totalCredit(v: number) { this._totalCredit = v; } public get totalCredit(): number { return this._totalCredit;} private _totalCredit: number;
    public set totalDebt(v: number) { this._totalDebt = v; } public get totalDebt(): number { return this._totalDebt;} private _totalDebt: number;
    public set totalBalance(v: number) { this._totalBalance = v; } public get totalBalance(): number { return this._totalBalance;} private _totalBalance: number;
        
}


